import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import qs from "query-string";
import Loader from "../components/BlueButton/Loader.js";
import {Col, Row} from "react-bootstrap";
import Wrapper from "../components/Wrapper.js";
import Button from "../components/Button/Button.js";
import {word} from "../word.js";
import NotificationItem from "../components/Notification/NotificationItem.js";
import Api from "../Api.js";
import AddNotification from "../components/Notification/AddNotification.js";
import {useDispatch, useSelector} from "react-redux";
import {notificationAddLocalRequest} from "../store/actions/notification.js";
import CustomPagination from "../components/BlueButton/CustomPagination.js";

function Notifications(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [see_notification, setSee_notification] = useState([]);
    const [notification, setNotification] = useState([]);
    const [count, setCount] = useState(0);
    const [activePage, setActivePage] = useState(1);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [activeId, setActiveId] = useState(1);
    const [filter, setFilter] = useState({});
    const parseQuery = () => qs.parse(location.search);
    const updateURL = (params) => {
        const stringify = qs.stringify(params);
        navigate(`?${stringify}`, {replace: true});
    };
    const fetchNotification = async (params,active) => {
        try {
            setLoading(true);
            const stringify = qs.stringify(params);
            const {data} = await Api.getNotification(stringify)
            if(active){
                if(active === 1){

                    setNotification(data.results);
                    dispatch(notificationAddLocalRequest(data.results));
                }else {
                    setSee_notification(data.results)
                }
            }else{
                if(activeId === 1){
                    setNotification(data.results);
                }else {
                    setSee_notification(data.results)
                }
            }

            setCount(data.count);
            const offset = parseInt(params.offset) || 0;
            setActivePage(offset ? offset / 10 + 1 : 1);
            setLoading(false);
        }catch (e) {

        }
    };

    const initFilter = async () => {
        const params = parseQuery();
        const id = localStorage.getItem("id");
        const profession = localStorage.getItem("profession");

        let newFilter = {};
        if(Object.keys(params).length === 0){
            if (profession === "accountant") {
                newFilter = {
                    accountants_client_eq: id,
                    accountant_neq: id,
                    accountant_eq: "",
                };
            } else {
                newFilter = {
                    manager_eq: "",
                    manager_neq: id,
                    managers_client_eq: id,
                };
            }
        }
        let active = 1
        if(params.manager_neq || params.accountant_neq){
            setActiveId(1)
            active = 1
        }else if(params.manager_eq || params.accountant_eq){
            setActiveId(2)
            active = 2
        }else if(params.manager){
            setActiveId(3)
            active = 3
        }
        const combined = {...newFilter, ...params};
        setFilter(combined);
        updateURL(combined);
        await fetchNotification(combined,active);
    };

    const handlePageChange = (pageNumber) => {
        const params = {
            ...filter,
            offset: pageNumber === 1 ? "" : (pageNumber - 1) * 10,
        };
        setFilter(params);
        updateURL(params);
        fetchNotification(params);
    };

    const getNotificationEq =async () => {
        const id = localStorage.getItem("id");
        const profession = localStorage.getItem("profession");

        const data =
            profession === "manager"
                ? {
                    manager_eq: id,
                    managers_client_eq: id,
                    manager_neq: "",
                }
                : {
                    accountant_eq: id,
                    accountant_neq: "",
                    accountants_client_eq: id,
                };

        setActiveId(2);
        setFilter(data);
        updateURL(data);
        await fetchNotification(data,2);
    };

    const getNotificationNeq = async () => {
        const id = localStorage.getItem("id");
        const profession = localStorage.getItem("profession");

        const data =
            profession === "manager"
                ? {
                    manager_eq: "",
                    manager_neq: id,
                    managers_client_eq: id,
                }
                : {
                    accountant_eq: "",
                    accountant_neq: id,
                    accountants_client_eq: id,
                };

        setActiveId(1);
        setFilter(data);
        updateURL(data);
        await fetchNotification(data,1);
    };

    const renderNotifications = () => {
        const data = activeId === 1 ? notification : see_notification;

        if (data && !loading) {
            return data.map((item, index) => (
                <Col md={6} key={index}>
                    <NotificationItem
                        getTaskData={initFilter}
                        {...props}
                        image_list={item.accountant_list}
                        toLink={`/main_employee/notification/${item.id}`}
                        companyId={`/main_employee/organization/${item.company_id}`}
                        comapanyName={item.company_name}
                        team={item.title}
                        teamText={item.description}
                        imgList={item.notification_file}
                        id={item.id}
                        date={item.date}
                        manager={item.manager}
                        modalShow={() => handleDelete(item.id)}
                    />
                </Col>
            ));
        } else if (loading) {
            return (
                <div className="loaderMargin">
                    <Loader size={30}/>
                </div>
            );
        } else {
            return <div className="no_tasks"/>;
        }
    };
    useEffect(() => {
        initFilter();
    }, []);
    const handleOwnNotification = async () => {
        const id = localStorage.getItem("id");
        setFilter({manager: id});
        setActiveId(3);
        updateURL({manager: id});
        await fetchNotification({manager: id},3);
    };
    return (
        <Wrapper>
            <div className="users">
                <div className="tasks-buttons">
                    <Button
                        buttonStyle={
                            activeId !== 1 ? "middle-button task-button" : "task-button-active"
                        }
                        title="Չբացված"
                        onChangeValue={async () => {
                            await getNotificationNeq();
                            setActiveId(1);
                        }}
                    />
                    <Button
                        buttonStyle={
                            activeId !== 2 ? "middle-button task-button" : "task-button-active"
                        }
                        title="Բացված"
                        onChangeValue={async () => {
                            await getNotificationEq();
                            setActiveId(2);
                        }}
                    />
                    {localStorage.getItem("profession") === "manager" && (
                        <Button
                            buttonStyle={
                                activeId !== 3 ? "middle-button task-button" : "task-button-active"
                            }
                            title="Իմ ավելացրած"
                            onChangeValue={handleOwnNotification}
                        />
                    )}

                </div>
                {localStorage.getItem("profession") === "manager" && (
                    <div className="plus-cont" onClick={() => setShow(true)}>
                        <span className="plus">+</span>
                        <span className="tooltiptext">{word.addItem}</span>
                    </div>
                )}
                <div className="tasks-cont">
                    <Row className="flex-row">{renderNotifications()}</Row>
                </div>
                {count > 10 && (
                    <div className="d-flex justify-content-center">
                        <CustomPagination
                            currentPage={+parseQuery().offset? parseQuery().offset/10 + 1  : 1}
                            totalItems={count}
                            itemsPerPage={10}
                            totalPages={Math.ceil(count / 10) || 0}
                            onPageChange={(newPage) => handlePageChange(newPage)}
                        />
                    </div>
                )}
            </div>
            {show?<AddNotification show={show} onHide={async () => {
                setShow(false);
                initFilter()
            }}/>:null }

        </Wrapper>
    );
}

export default Notifications;